import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    meta: {
      'title': '首页',
      'icon': 'el-icon-house'
    },
    isSubmenu: false,
    component: () => import('../views/HomeView.vue')
  },
  {
    path: '/user',
    meta: {
      'title': '用户管理',
      'icon': 'el-icon-user-solid'
    },
    isSubmenu: true,
    roles: ['admin', 'sales'],
    component: () => import('../components/FirstMenu.vue'),
    children: [{
      path: '/userlist',
      name: 'UserList',
      isShow: true,
      roles: ['admin', 'sales'],
      component: () => import('@/views/user/UserList'),
      meta: { title: '用户列表', keepAlive: true }
    }, {
      path: '/user-api-bill/:id',
      name: 'UserApiBill',
      isShow: false,
      roles: ['admin', 'sales'],
      component: () => import('@/views/user/UserApiBill'),
      meta: { title: '用户API账单', keepAlive: true }
    }]
  },
  {
    path: '/line',
    meta: {
      'title': '专线管理',
      'icon': 'el-icon-connection'
    },
    isSubmenu: true,
    roles: ['admin'],
    component: () => import('../components/FirstMenu.vue'),
    children: [{
      path: '/linelist',
      name: 'LineList',
      isShow: true,
      roles: ['admin'],
      component: () => import('@/views/line/LineList'),
      meta: { title: '专线列表', keepAlive: true }
    }]
  },
  {
    path: '/live',
    meta: {
      'title': '直播管理',
      'icon': 'el-icon-video-camera'
    },
    isSubmenu: true,
    roles: ['admin'],
    component: () => import('../components/FirstMenu.vue'),
    children: [{
      path: '/livelist',
      name: 'LiveList',
      isShow: true,
      roles: ['admin'],
      component: () => import('@/views/live/LiveList'),
      meta: { title: '直播列表', keepAlive: true }
    }, {
      path: '/configdata',
      name: 'ConfigData',
      isShow: true,
      roles: ['admin'],
      component: () => import('@/views/line/ConfigData'),
      meta: { title: '推流逻辑配置', keepAlive: true }
    }]
  },
  {
    path: '/product',
    meta: {
      'title': '产品管理',
      'icon': 'el-icon-menu'
    },
    isSubmenu: true,
    roles: ['admin'],
    component: () => import('../components/FirstMenu.vue'),
    children: [{
      path: '/productlist',
      name: 'ProductList',
      isShow: true,
      roles: ['admin'],
      component: () => import('@/views/product/ProductList'),
      meta: { title: '产品列表', keepAlive: true }
    }]
  },
  {
    path: '/order',
    meta: {
      'title': '订单管理',
      'icon': 'el-icon-s-order'
    },
    isSubmenu: true,
    roles: ['admin'],
    component: () => import('../components/FirstMenu.vue'),
    children: [{
      path: '/orderlist',
      name: 'OrderList',
      isShow: true,
      roles: ['admin'],
      component: () => import('@/views/order/OrderList'),
      meta: { title: '订单列表', keepAlive: true }
    }]
  },
  {
    path: '/company',
    meta: {
      'title': '企业认证',
      'icon': 'el-icon-s-flag'
    },
    isSubmenu: true,
    roles: ['admin'],
    component: () => import('../components/FirstMenu.vue'),
    children: [{
      path: '/companylist',
      name: 'CompanyList',
      isShow: true,
      roles: ['admin'],
      component: () => import('@/views/company/CompanyList'),
      meta: { title: '企业认证列表', keepAlive: true }
    }]
  },
  {
    path: '/veefilm',
    meta: {
      'title': '一镜到底',
      'icon': 'el-icon-video-camera-solid'
    },
    isSubmenu: true,
    roles: ['admin'],
    component: () => import('../components/FirstMenu.vue'),
    children: [
      {
        path: '/imagelist',
        name: 'ImageList',
        isShow: true,
        roles: ['admin'],
        component: () => import('@/views/veefilm/ImageList'),
        meta: { title: '文生图列表', keepAlive: true }
      },
      {
        path: '/videolist',
        name: 'VideoList',
        isShow: true,
        roles: ['admin'],
        component: () => import('@/views/veefilm/VideoList'),
        meta: { title: '图生视频列表', keepAlive: true }
      }
    ]
  },
  {
    path: '/shortvideo',
    meta: {
      'title': '捞漫地',
      'icon': 'el-icon-video-camera-solid'
    },
    isSubmenu: true,
    roles: ['admin'],
    component: () => import('../components/FirstMenu.vue'),
    children: [
      {
        path: '/configuration',
        name: 'Configuration',
        isShow: true,
        roles: ['admin'],
        component: () => import('@/views/shortvideo/Configuration'),
        meta: { title: '平台配置', keepAlive: true }
      },
      {
        path: '/accountlist',
        name: 'AccountList',
        isShow: false,
        roles: ['admin'],
        component: () => import('@/views/shortvideo/AccountList'),
        meta: { title: '账号列表', keepAlive: true }
      },
      {
        path: '/tokenlist',
        name: 'TokenList',
        isShow: false,
        roles: ['admin'],
        component: () => import('@/views/shortvideo/TokenList'),
        meta: { title: 'Token列表', keepAlive: true }
      },
      {
        path: '/projectsresult',
        name: 'ProjectsResult',
        isShow: false,
        roles: ['admin'],
        component: () => import('@/views/veefilm/ProjectsResult'),
        meta: { title: '项目详情', keepAlive: true }
      },
      {
        path: '/inspiration',
        name: 'Inspiration',
        isShow: true,
        roles: ['admin'],
        component: () => import('@/views/inspiration/Inspiration'),
        meta: { title: '灵感列表', keepAlive: true }
      },
      {
        path: '/shortvideo/companylist',
        name: 'ShortVideoCompanyList',
        isShow: true,
        roles: ['admin'],
        component: () => import('@/views/shortvideo/CompanyList'),
        meta: { title: '公司列表', keepAlive: true }
      },
      {
        path: '/shortvideo/configurationlist',
        name: 'ShortVideoConfigurationList',
        isShow: false,
        roles: ['admin'],
        component: () => import('@/views/shortvideo/ConfigurationList'),
        meta: { title: '公司平台列表', keepAlive: true }
      },
    ]
  },
  {
    path: '/census',
    meta: {
      'title': '数据统计',
      'icon': 'el-icon-s-data'
    },
    isSubmenu: true,
    roles: ['admin', 'finance'],
    component: () => import('../components/FirstMenu.vue'),
    children: [
      {
        path: '/user-day',
        name: 'CensusUserDay',
        isShow: true,
        roles: ['admin', 'finance'],
        component: () => import('@/views/census/userDay'),
        meta: { title: '用户消耗统计', keepAlive: true }
      },
      {
        path: '/model-day',
        name: 'CensusModelDay',
        isShow: true,
        roles: ['admin', 'finance'],
        component: () => import('@/views/census/modelDay'),
        meta: { title: '模型消耗统计', keepAlive: true }
      },
      {
        path: '/bill-list',
        name: 'BillList',
        isShow: true,
        roles: ['admin', 'finance'],
        component: () => import('@/views/census/billList'),
        meta: { title: '账单列表', keepAlive: true }
      }
    ]
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
